// src/components/TawkToWidget.jsx
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const TawkToWidget = () => {
  const globalData = useSelector((state) => state.globalData.globalDataName);
  const tawkUrl = globalData?.tawkLink;

  useEffect(() => {
    if (!tawkUrl) return;

    // Prevent multiple loads
    if (document.getElementById('tawk-script')) return;

    const s1 = document.createElement('script');
    s1.id = 'tawk-script';
    s1.async = true;
    s1.src = tawkUrl;
    s1.charset = 'UTF-8';
    s1.setAttribute('crossorigin', '*');

    // Load lazily after full window load
    const onLoad = () => {
      document.body.appendChild(s1);
    };

    if (document.readyState === 'complete') {
      onLoad();
    } else {
      window.addEventListener('load', onLoad);
    }

    return () => {
      window.removeEventListener('load', onLoad);
    };
  }, [tawkUrl]);

  return null;
};

export default TawkToWidget;

